const releases = [
    {
        date: '08/2026',
        versions: [
            {
                version: '4.52.0',
                title: '18.08.2026',
                notes: [
                    'Administracja: Domyślny system mierzenia ustawiany z poziomu parametrów specyfikacji (zakładka Rozmiary), analogicznie do sezonu roboczego',
                    'Specyfikacja: Nowa specyfikacja dostaje system mierzenia oznaczony jako domyślny zamiast standardu wybieranego po nazwie',
                    'Specyfikacja: Wybrany system mierzenia jest oznaczany na liście w kroku Wolumen produkcji',
                    'Specyfikacja: Fix białego ekranu w kroku Wolumen produkcji dla specyfikacji bez systemu mierzenia',
                ],
            },
            {
                version: '4.51.0',
                title: '12.08.2026',
                notes: [
                    'Specyfikacja: Poprawiona obsługa wariantów komponentów przy częściowych danych z API',
                ],
            },
            {
                version: '4.50.0',
                title: '09.08.2026',
                notes: [
                    'Specyfikacja: Szybsze ładowanie zakładek komponentów. Optymalizacja zapytań bazo danowych.',
                    'Specyfikacja: Poprawiona synchronizacja danych i statusu po zatwierdzeniu draftu',
                ],
            },
            {
                version: '4.40.2',
                title: '03.08.2026',
                notes: [
                    'Design System: Toasty',
                    'Design System: Tooltipy',
                    'Administracja: Fix edycji rozmiarów',
                    'Administracja: Fix wymiarów modelu',
                    'Administracja: Codzienna automatyczna aktualizacja walut',
                ],
            },
        ],
    },
    {
        date: '07/2026',
        versions: [
            {
                version: '4.40.1',
                title: '31.07.2026',
                notes: [
                    'Design System: Poprawki buttonów i fontów w modalach, sidebarach',
                    'Modale potwierdzające',
                ],
            },
            {
                version: '4.40.0',
                title: '30.07.2026',
                notes: ['Specyfikacja: Implementacja nowych customowych statusów specyfikacji'],
            },
            {
                version: '4.39.1',
                title: '29.07.2026',
                notes: [
                    'Specyfikacja: Design dodawania rzutów i komentarzy',
                    'Generowanie PDF: Przerzucanie rzutów na nowe strony, niepokazywanie rzutu z komentarzami konstruktorskimi gdy ich nie ma',
                ],
            },
            {
                version: '4.39.0',
                title: '27.07.2026',
                notes: [
                    'Design System: Fonty',
                    'Design System: Paddingi',
                    'Design System: Dropdowny',
                    'Design System: Modale',
                    'Poprawki językowe i funkcjonalne od zespołu produkcyjnego',
                    'Dodanie buttonu chata w karcie specyfikacji',
                ],
            },
            {
                version: '4.38.7',
                title: '23.07.2026',
                notes: [
                    'HOTFIX: Generowanie PDF - polskie znaki, margines opisu dodatkowego, komentarze w liście pod obrazkiem rzutu',
                ],
            },
            {
                version: '4.38.6',
                title: '17.07.2026',
                notes: [
                    'HOTFIX: Wyświetlanie wszystkich dostawców/operatorów zamówień przy dodawaniu komponentu',
                ],
            },
            {
                version: '4.38.5',
                title: '14.07.2026',
                notes: [
                    'FIX: Okrojenie zapytania o kosztorys ze zbędnych danych',
                    'FIX: Ograniczenie liczby wywołań kalkulacji błędów specyfikacji',
                    'Specyfikacja: Koszty komponentów: Zmiana ikonki - warning o różniących się cenach',
                    'Specyfikacja: Koszty komponentów: Rozwijanie tabelki z wariantami',
                    'Usunięcie nieużywanego legacy kodu',
                    'Migracja plików js/jsx do typescripta',
                    `Przygotowania do bumpa wersji Reacta`,
                ],
            },
            {
                version: '4.38.4',
                title: '10.07.2026',
                notes: [
                    'Generowanie PDFów specyfikacji wraz z PDFami komponentów',
                    'FIX: Breadcrumb and send icons',
                ],
            },
            {
                version: '4.38.3',
                title: '09.07.2026',
                notes: [
                    'FIX: Generowanie PDFów',
                    'Lista Komponentów przy dodawaniu komentarza do projekcji',
                ],
            },
            {
                version: '4.38.2',
                title: '09.07.2026',
                notes: ['Optymalizacja ładowania listy specyfikacji i folderów'],
            },
            {
                version: '4.38.1',
                title: '08.07.2026',
                notes: ['Walidacja specyfikacji', 'Poprawione ikony', 'Poprawione paddingi'],
            },
        ],
    },
    {
        date: '06/2026',
        versions: [
            {
                version: '4.38.0',
                title: '30.06.2026',
                notes: [
                    'Rozdzielenie zapytań w widkoach specyfikacji na poszczególne taby - Przyspieszenie ładowania detali i podglądu specyfikacji (lazy loading - nie ładujemy wszystkich danych w pierwszym zapytaniu)',
                    'Nowa grubość ikony',
                ],
            },
            {
                version: '4.37.2',
                title: '29.06.2026',
                notes: [
                    'FIX: Możliwość dodania/edytowania wariantów w momencie gdy dodamy nowy komponent w trybie Kreatora Specyfikacji',
                ],
            },
            {
                version: '4.37.0',
                title: '25.06.2026',
                notes: [
                    'FormField: Komponent do wyświetlania błędów poszczególnych pól formularzy + animacja + testy',
                    'Biblioteka Komponentów: Walidacja (wymagane nazwa, kategoria, operator zamówienia, dostawca, opis jeśli conajmniej 5 znaków)',
                    'Warianty komponentów: Walidacja (wymagane cena, waluta, kolor)',
                    'Dostawcy: Walidacja (wymagana nazwa, nazwa skrócona i kod dostawcy)',
                    'Operatorzy zamówień: Walidacja (wymagana nazwa)',
                    'Producenci: Walidacja (wymagana nazwa i nazwa skrócona)',
                    'Administracja: Walidacja (dla wszystkich wymagana tylko nazwa)',
                    'Administracja: Walidacja rozmiarów',
                    'Administracja: Zarządzanie - Toasty z informacją jeśli akcja się powiodła.',
                    'Specyfikacje: Walidacja i obsługa błędów Folderów i przenoszenia Folderów i Specyfikacji',
                    'Inbox: Walidacja kanału',
                ],
            },
            {
                version: '4.36.0',
                title: '24.06.2026',
                notes: [
                    'Kreator Specyfikacji: znacznie przyspieszone dodawanie wielu komponentów do specyfikacji',
                    'Komponenty: szybsze ustalanie kolejności komponentów przy dodawaniu nowych pozycji',
                    'Biblioteka komponentów: szybsze ładowanie i filtrowanie dużych list komponentów',
                    'Dostawcy: szybsze ładowanie i filtrowanie dużych list dostawców',
                ],
            },
            {
                version: '4.35.1',
                title: '19.06.2026',
                notes: [
                    'Design System: Poprawiony widok tabeli',
                    'Komponenty: Walidacja kontynentu i kraju',
                    'Lista zamówień jako tabela',
                    'Lista wydań magazynowych jako tabela',
                    'Podmienione ikony - m.in. zamówienia, wydania magazynowe, edytuj, usuń',
                ],
            },
            {
                version: '4.35.0',
                title: '17.06.2026',
                notes: [
                    'Administracja: nowy parametr produktu: Kraj',
                    'Filtrowanie Krajów po kontynencie',
                    'Czas realizjacji - nieobowiązkowy (ale wymgany do zatwierdzenia specyfikacji)',
                    'Usunięcie legacy kodu',
                ],
            },
        ],
    },
    {
        date: '05/2026',
        versions: [
            {
                version: '4.34.0',
                title: '25.05.2026',
                notes: [
                    'Design System: System Alert',
                    'Design System: Toast',
                    'Kreator Specyfikacji: Możliwość generowania PDF dla draftu specyfikacji z wypełnionym pierwszym krokiem',
                    'Kreator Specyfikacji: Możliwość pominięcia 4. kroku (Zużycie)',
                    'Chat: Link do PDF',
                    'Chat: Kopiowanie linku do PDF do schowka',
                    'Chat: Wysłane w wiadomości linki są klikalne',
                    'Administracja: zarządznie kategorie produktów, sortowanie, edycja, filtr',
                    'Administracja: zarządzanie paremaetrami produktu: Funkcje, Zrównoważony rozwój, Certifikaty, Kontynenty, Targi, Kategorie',
                    'Kreator Specyfikacj: Wybór komponentu, PDF, Wydania: sortowanie po ustawieniach w administracji',
                ],
            },
            {
                version: '4.33.0',
                title: '22.05.2026',
                notes: ['Design System: Photo Preview', 'Karta Produktu'],
            },
            {
                version: '4.32.0',
                title: '20.05.2026',
                notes: ['Karta Produktu', 'Design System: Multiselect'],
            },
            {
                version: '4.31.0',
                title: '13.05.2026',
                notes: [
                    'Dark mode',
                    'Design System: Sidebar',
                    'Design System: Modal',
                    'Design System: Taby z animacją',
                    'Długa lista linków: Rozwinięcie pokazywane w modalu',
                    'Tooltip na buttonie przejścia do kolejnego kroku w Wizardzie Specyfikacji',
                    'Nowe Ikony',
                ],
            },
            {
                version: '4.30.0',
                title: '11.05.2026',
                notes: [
                    'Dark mode',
                    'Design System: Checkbox',
                    'Design System: Input',
                    'Design System: Switch',
                ],
            },
        ],
    },
    {
        date: '04/2026',
        versions: [
            {
                version: '4.29.1',
                title: '30.04.2026',
                notes: ['Fix Generowania PDF komponentów'],
            },
            {
                version: '4.29.0',
                title: '30.04.2026',
                notes: ['Design System: Kolory', 'Design System: Avatar', 'Design System: Buttony'],
            },
            {
                version: '4.28.1',
                title: '28.04.2026',
                notes: ['Fix: Generowanie PDF specyfikacji'],
            },
            {
                version: '4.28.0',
                title: '27.04.2026',
                notes: ['Zamówienia, Wydania Magazynowe: Wyszukiwanie'],
            },
            {
                version: '4.27.0',
                title: '24.04.2026',
                notes: [
                    'Paginacja - przyklejona do dolnej krawędzi z marginesami',
                    'Dostawcy, Operatorzy, Producenci - implementacja nowego stylu tabel, loadery',
                    'Stary komponent tabeli usunięty - we wszystkich miejscach zastąpiony nowym',
                ],
            },
            {
                version: '4.26.0',
                title: '22.04.2026',
                notes: [
                    'Zamówienia: Odbiory domyśknie rozwiń listę komoonentów w dostawie',
                    'Zamówienia: powrót do kreatora zamówienia jeśli nie posiada pierwzego terminu dostawy',
                    'Zamówienia: zmiana menu kontekstowego dla zamówień bez daty pierwszej dostawy, tylko opcja edycji zamówienia',
                    'Zamówienia: groupowanie dostaw po dostawcach w kalendarzu planowania',
                ],
            },
            {
                version: '4.25.0',
                title: '20.04.2026',
                notes: [
                    'Paginacja - zmiana zasad pokazywania/ukrywania stron z wynikami',
                    'Pola tekstowe: Input w prawym rogu pokazujący update informacji',
                    'Warianty komponentów: Loadery przy dodawaniu/edycji',
                    'Inputy Wolumenu, Ceny, Ilości: Dodanie loaderów',
                ],
            },
            {
                version: '4.24.0',
                title: '14.04.2026',
                notes: [
                    'Wydania magazynowe: paginacja',
                    'Wizard Zamówienia: puste zamówienie (bez specyfikacji) jest automatycznie usuwane',
                    `Button: Focused`,
                ],
            },
            {
                version: '4.23.0',
                title: '09.04.2026',
                notes: [
                    'Wizard Zamówienia - przeniesiony do modala i layout uwspólniony z wizardem specyfikacji',
                    'Loader na checkboxie - w trakcie dodawania specyfikacji do zamówienia',
                    'Fix: Brak wariantów komponentów w Wolumenie Zamówienia',
                    'Fix: Brak wariantów komponentów w Wydaniu Magazynowym',
                    'Modale potwierdzające usunięcie zamówienia, wydania magazynowego',
                    'Wydanie magazynowe: brakujące loadery',
                    'Usunięcie możliwości zmiany nazwy wariantu po zatwierdzeniu specyfikacji',
                ],
            },
        ],
    },
    {
        date: '03/2026',
        versions: [
            {
                version: '4.22.2',
                title: '31.03.2026',
                notes: [
                    'Fix kreatora specyfikacji - aktualizacja statusu kroków po usunięciu komponentów',
                    'Kreator specyfikacji - startowy krok - pierwszy lub pierwszy nieuzupełniony',
                    'Nowy wygląd komponentu Switch',
                    'Migracja plików JavaScript do TypeScript',
                    'Usunięcie nieużywanego kodu',
                    'Obsługa domyślnej waluty tenanta zpias w bazie danych i uzycie w aplikacji',
                    'Zaznaczenie domyślnej waluty w komponentach',
                    'Administacja wybór domyślnej waluty tenanta',
                    'Automatyczne uzupełnianie waluty w wariantach produktów',
                ],
            },
            {
                version: '4.22.1',
                title: '24.03.2026',
                notes: [
                    'Kreator: Wybór komponentów: Usunięcie kroku z listą kategorii - przeniesienie jej do menu bocznego na liście komponentów',
                    'Wyświetlanie liczby wybranych komponentów, które zostały wybrane do dodania',
                    'Usunięcie komponentu skeleton loadera',
                ],
            },
            {
                version: '4.22.0',
                title: '23.03.2026',
                notes: [
                    'Kreator Specyfikacji: Brak moźliwości przejścia do kolejnego korku bez potrzebnych informacji',
                    'Nowy wygląd i układ: Podgląd komponentu specyfikacji w kreatorze',
                    'Wyświetlanie szczegółow komponentu w modalu',
                    'Wyodrebnienie dostawcy do osobnej cześci danych komponentu',
                    'Karta Dostawcy',
                    'Zmiana zakładek w podglądzie komponentu',
                    'Ikonki 3d',
                    'Fix buttonów zamykania, opcji, dropdown w modalu, sidebarze',
                    'Zmiana głownego koloru z niebieskiego na ciemny',
                    'Oznaczanie zrealizowanych kroków w kreatorze specyfikacji',
                ],
            },
            {
                version: '4.21.1',
                title: '18.03.2026',
                notes: [
                    'Fix: Modal niekompletnej specyfikacji w kreatorze',
                    'Oznaczanie zrealizowanych kroków w kreatorze specyfikacji',
                ],
            },
            {
                version: '4.21.0',
                title: '13.03.2026',
                notes: [
                    'Planowanie zamówienia: workflow zatwierdzania produkcji dla specyfikacji (zatwierdź, podgląd, powrót do planowania).',
                    'Manager produkcji: po zatwierdzeniu specyfikacja jest w trybie podglądu i ma blokadę edycji (producent, priorytet, data startu, alokacje).',
                    'Kalendarz producenta: oznaczenie dni zajętych oraz tooltip z zamówieniami i listą realizowanych specyfikacji.',
                    'Planowanie: podświetlenie dni produkcyjnych w kalendarzu podglądu oraz rozszerzona legenda.',
                    'Planowanie: dodatkowe tooltipy dla czasu produkcji i wydajności producenta.',
                ],
            },
            {
                version: '4.20.2',
                title: '11.03.2026',
                notes: ['Fix: Zamówienie - kalendarz dostaw', 'Fix: Testy E2E'],
            },
            {
                version: '4.20.1',
                title: '02.03.2026',
                notes: [
                    'Fix: Wydania magazynowe - zmiana specyfikacji i odświeżanie strony',
                    'Fix: Wizard specyfikacji - usuwanie/dodawanie wersji w Wolumenie',
                    'Wizard specyfikacji - błędy w konsoli',
                ],
            },
        ],
    },
    {
        date: '02/2026',
        versions: [
            {
                version: '4.20.0',
                title: '27.02.2026',
                notes: [
                    'Fix: Informacja o konieczności wybrania kolorów dla wszystkich wariantów przed wybraniem rozmiaru',
                    'Fix: Rozmiar tabeli w Wariantach Komponentów',
                    'Fix: Maksymalna szerokość komponentu switch',
                ],
            },
            {
                version: '4.19.3',
                title: '24.02.2026',
                notes: [
                    'Moliwość Edycji koloru w Wizard specyfikacji',
                    'Formularz Edycji Producenta',
                    'Pdf Preview dla karty komponentu',
                ],
            },
            {
                version: '4.19.2',
                title: '20.02.2026',
                notes: [
                    'Fix: Generowanie PDF po bumpie wersji',
                    'Fix: Dropdown przy dolnej krawędzi okna przeglądarki',
                    'Fix: Doładowywanie komponentów w modalu na scroll',
                ],
            },
            {
                version: '4.19.1',
                title: '17.02.2026',
                notes: ['Fix: Generowanie PDF po bumpie wersji'],
            },
            {
                version: '4.19.1',
                title: '17.02.2026',
                notes: [
                    'Aktualizacja bibliotek: react-pdf, lodash, lodash-es, moment, webpack oraz usunięcie nieużywanych zależności (immer, babel-eslint)',
                    'Aktualizacja bibliotek: headlessui, redux-toolkit, classnames, i18next, react-i18next i inne (patch/minor)',
                    'Fix: Generowanie PDF po bumpie wersji',
                    'Fix: Dropdown po bumpie wersji',
                    'Fix: Komponent Avatar - obsługa pustych stringów w inicjałach',
                    'Fix: Edycja producentów - uwspólnienie widoków',
                ],
            },
            {
                version: '4.19.0',
                title: '16.02.2026',
                notes: [
                    'Kreator Specyfikacji: Otwieranie modala z określoną zakładką (np. Komponenty, Warianty itp.)',
                    'Dodaj producenta: Dropdown dodawania dni wolnych',
                    'Dodaj operatora zamówień: Fix modala',
                    'Dodaj dostawcę: Fix modala',
                    'Fix: Naprawa testów E2E',
                ],
            },
            {
                version: '4.18.0',
                title: '10.02.2026',
                notes: [
                    'Kreator Specyfikacji - Informacje: Kreator specyfikacji: Buttony dodawania Brandu, Kategorii, Sezonu pry wyborze',
                    'Kreator Specyfikacji - Wolumen: Modal edycji zmiany wersji',
                    'Kreator Specyfikacji - Wolumen: Dodanie loaderów na buttonach akcji',
                    'Kreator Specyfikacji - Komponenty: Dodawanie i edycja komponentów. Jeśli komponent nie ma wariantu to nie da się go zaznaczyć. W tooltipie info, że trzeba dodać wariant.',
                    'Fix: Kreator Specyfikacji zasłania Buttony Chata i Screenshota',
                    'Fix: Naprawa testów E2E',
                ],
            },
            {
                version: '4.17.1',
                title: '04.02.2026',
                notes: [
                    'Po edycji komponentu, nie zamykać sidebara z podglądem komponentu',
                    'Dodanie opcji przejścia do dokładnego podglądu specyfikacji w podglądzie (ikonka, prawy górny róg)',
                    'Poprawki widoku podglądu specyfikacji w sidebarze',
                ],
            },
            {
                version: '4.17.0',
                title: '03.02.2026',
                notes: [
                    'Nowy komponent nawigacji sidebar - lista buttonów z tłem, wychodząca poza obiekt, w którym się znajduje',
                    'Podgląd specyfikacji',
                    'Podgląd komponentu',
                    'Nowy wygląd karty komponentu przy wyborze w specyfikacji',
                    'Nowy wygląd karty komponentu na liście komponentów',
                ],
            },
        ],
    },
    {
        date: '01/2026',
        versions: [
            {
                version: '4.16.0',
                title: '27.01.2026',
                notes: [
                    'Fix obsługi błędów przy ładowaniu specyfikacji (produkcyjnej i draftów)',
                    'Obsługa podglądów komponentu, specyfikacji, chatu jako globalny komponent (wyeliminowanie błędów, duplikowanego kodu)',
                    'Nowy wygląd Tabel (Wolumen Produkcji, Warianty)',
                    'Nowy wygląd Sidebara',
                ],
            },
            {
                version: '4.15.0',
                title: '25.01.2026',
                notes: [
                    'Ulepszenia w module Managera Produkcji (liczniki modeli, ikony producentów, sygnalizacja braków)',
                    'Ulepszenia w Planowaniu produkcji (wyliczenia czasu, daty wirtualne, info o brakach w danych)',
                    'Manager produkcji: data startu produkcji ograniczona do ostatniej daty odbioru dla specyfikacji',
                ],
            },
            {
                version: '4.14.0',
                title: '21.01.2026',
                notes: [
                    'Formularz edycji producenta oraz kolumna liczby pracowników na liście producentów',
                    'Kalendarz dni wolnych producenta (zakresy i pojedyncze daty) z podglądem w edycji',
                    'Manager produkcji: wybór daty startu produkcji z kalendarza oraz blokada bez pełnych alokacji',
                    'Planowanie: kalendarz z wirtualną datą zakończenia produkcji',
                    'Planowanie: modal "Zatwierdź produkcję" z danymi specyfikacji, producenta, mozliwosci produkcji i dni wolnych',
                    'Specyfikacje: pole "Czas realizacji (w minutach)" w sekcji Informacje ogólne',
                ],
            },
            {
                version: '4.13.2',
                title: '20.01.2026',
                notes: [
                    'Edycja niezatwierdzonej specyfikacji w kreatorze (modalu)',
                    'Przełączanie rzutów w komentarza w kreatorze specyfikacji',
                    'Modal z brakującymi informacjami - przełączanie tabów kreatora specyfikacji',
                    'Dropdown z akcjami specyfikacji - dostosowanie do nowego layoutu',
                    'Ustawienie sezonu roboczego jako domyślnego w kreatorze specyfikacji',
                    'Fix zdjęcia produkcyjnej specyfikacji',
                    'Generowanie PDF specyfikacji - dostosowanie do nowego layoutu',
                ],
            },
            {
                version: '4.13.1',
                title: '05.01.2026',
                notes: [
                    'Kreator specyfikacji oddzielony od edycji specyfikacji',
                    'Manager produkcji: Przydzielanie producenta do specyfikacji',
                    'Manager produkcji: Przydzielanie priorytetu specyfikacji',
                    'Manager produkcji: Przydzielanie odebranych komponentów zamówienia do produkcji',
                    'Edycja wolumenu zablokowana dla zatwierdzonej specyfikacji',
                    'Poprawki zapisu specyfikacji w kreatorze specyfikacji, dodanie tlumaczenia PL i EN w kreatorze specyfikacji',
                ],
            },
            {
                version: '4.13.0',
                title: '05.01.2026',
                notes: ['Kreator specyfikacji oddzielony od edycji specyfikacji'],
            },
        ],
    },
    {
        date: '12/2025',
        versions: [
            {
                version: '4.12.1',
                title: '31.12.2025',
                notes: [
                    'Odbiory, Manager produkcji schodzą pod poszczególne zamówienia w drzewie strony',
                    'Oznaczanie specyfikacji jako przypisanej do zamówienia w widoku specyfikacji - fix',
                ],
            },
            {
                version: '4.12.0',
                title: '29.12.2025',
                notes: [
                    'Liczniki dla zamówień, opóźnione zamówienia oraz w trakicie realizacji',
                    'Menu kontekstowe dla specyfikacji przejście do kalendarza odbiorów, managera produkcji, planowania dostawy oraz wysyłek',
                    'Oznaczanie specyfikacji jako przypisanej do zamówienia w widoku specyfikacji',
                    'Dashboard - liczniki zamówień, opóźnione zamówienia oraz w trakicie realizacji',
                    'Dashboard - komponent postępu w realizacji specyfikacji zasiliany danymi z backendu',
                    'Kropki statusu w zamówieniach przy statusie zamówienia',
                ],
            },
            {
                version: '4.11.3',
                title: '20.12.2025',
                notes: ['Breadcrumby', 'Zachowanie menu bocznego przy poszczególnych krokach zamówienia'],
            },
            {
                version: '4.11.2',
                title: '16.12.2025',
                notes: [
                    'Topbar zawsze widoczny - ustawiony na fixed',
                    'Drzewo z folderami - nowy layout',
                    'Fix wielkości fontów',
                ],
            },
            {
                version: '4.11.1',
                title: '11.12.2025',
                notes: [
                    'Przeniesienie i ujednolicenie buttonów do tworzenia nowych elementów w modułach',
                    'Przeniesienie wyszukiwania',
                    'Liczba nieodczytanych wiadomości i notfikacji w menu bocznym',
                    'Zafixowanie wysokości dropdowna z notyfikacjami',
                    'Wiadomości: Zmiana layoutu',
                ],
            },
            {
                version: '4.11.0',
                title: '08.12.2025 - Nowy Layout',
                notes: [
                    'Nowy background całej aplikacji',
                    'Przeniesienie informacji o zalogowanym uytkowniku do menu bocznego',
                    'Przeniesienie notyfikacji do menu bocznego',
                    'Nowy rozmiar głównej cześći aplikacji',
                ],
            },
        ],
    },
    {
        date: '11/2025',
        versions: [
            {
                version: '4.10.5',
                title: '28.11.2025',
                notes: [
                    'Modal przypisania producenta: Wyszukiwanie po nazwie',
                    'Product Manager: Kliknięcie priorytetu/Producenta odpala modal do zmiany',
                ],
            },
            {
                version: '4.10.4',
                title: '27.11.2025',
                notes: [
                    'Modal ustawienia priorytetu',
                    'Modal przypisania producenta',
                    'Refaktor kolorów statusów',
                    'Empty statets w kalendarzu odbiorów i managerze produkcji',
                ],
            },
            {
                version: '4.10.3',
                title: '25.11.2025',
                notes: ['Nowy widok managera produkcji', 'Dashboard - pierwsze widgety'],
            },
            {
                version: '4.10.2',
                title: '25.11.2025',
                notes: [
                    'Producenci: lista, filtr i archiwizacja',
                    'Producenci: dodawanie zdjęcia',
                    'Producenci: formularz dodawania nowego producenta',
                    'Menu bar ikona do listy producentów',
                ],
            },
            {
                version: '4.10.1',
                title: '24.11.2025',
                notes: [
                    'Zamówienie - Timeline: Fix paginacji po wyborze filtrowania po dostawcy',
                    'Zamówienie - Filtrowanie po statusie',
                    'Zamówienie - Planowanie: Sortowanie chronologiczne dostaw w popupie planowania dostawy',
                    'Zamówienie - Planowanie: Pokazywanie ikonki statusu dostawy w popupie planowania dostawy',
                    'Zamówienie - Pokazywanie "szarego" statusu w kolumnie ze statusem wariantu komponentu',
                    'Zamówienie - Liczniki dostaw wariantów komponentów w topie szczegółów zamówienia',
                    'Lista zamówień - Fix mignięcia pełnej listy przed ustawieniem filtrowania po sezonie roboczym',
                    'Link do Panelu Administracyjnego przeniesiony do dropdowna z Panelem Użytkownika, Zmianą Języka i wylogowaniem',
                ],
            },
            {
                version: '4.10.0',
                title: '20.11.2025',
                notes: [
                    'Nowy widok kalendarza',
                    'Kalendarz paginacja',
                    'Liczniki w kalendarzu odbirów: zrealizowane, opóźnione, w czasie realizacji',
                    'Filtr po statuse kalendarz obdiorów',
                ],
            },
            {
                version: '4.9.9.1',
                title: '18.11.2025',
                notes: [
                    'Stronicowanie dostawców w kalendarzu "Odbiory" zamówienia',
                    'Naprawa przelacznika Zatwierdź w Wolumenie Produkcji zamówienia',
                    'Zapamiętanie wybranej strony w kalendarzu po zmianach w formularzu planowania dostawy',
                    'Usunięcie kodu związanego z oknem Odbioru Dostawy zamówienia',
                    'Jedno okno do zarządzania odbiorami "Planowanane dostawy" w kalendarzu "Odbiory"',
                    'Przelacznik Odbierz w oknie "Planowanie dostawy"',
                    'Filtr po Dostawcy w kalendarzu "Odbiory"',
                ],
            },
            {
                version: '4.9.9',
                title: '12.11.2025',
                notes: [
                    'Komponent wykresu kołowego pokazującego stopień realizacji zamówień',
                    'Komponent switch w modalu planowania dostawy',
                    'Timeline - Oznaczenie opóźnionych zamówień',
                    'Fix: Kalendarz - 1 grudnia 2025',
                    'Kalendarz - Ograniczenie możliwych dat do wyboru',
                ],
            },
            {
                version: '4.9.8',
                title: '10.11.2025',
                notes: [
                    'Dodanie możliwości ustawienia daty dostawy realizacji zamówienia w ostatnim kroku kreatora zamówienia',
                    'Usunięcie logiki wyliczania daty realizacji komponentu na podstawie czasu realizacji produktu w zamówieniach',
                    'Moliwość wyboru sezonu roboczego na liście sezonów: Administracja',
                    'Flitrowanie zamówień po sezonach',
                    'Zapis sezonu roboczego dla zamówienia podczas tworzenia zamówienia',
                ],
            },
        ],
    },
    {
        date: '10/2025',
        versions: [
            {
                version: '4.9.7',
                title: '31.10.2025',
                notes: [
                    'Specyfikacja raz zamówiona nie może zostać dodana ponownie do zamówienia',
                    'Oznaczenie specyfikacji będącej już częścią innego zamówienia w kreatorze zamówienia',
                    'Refactoring kodu kreatora zamówienia',
                    'Refactoring kodu manageria odbiorów',
                    'Refactoring kodu managera produkcji',
                    'Usunięcie legacy kodu',
                ],
            },
            {
                version: '4.9.6',
                title: '28.10.2025',
                notes: [
                    'Komponent tabeli - widoki Dostawców i Operatorów zamówień',
                    'Manager Zamówień - fixy UI',
                    'Nowy komponent tabów',
                ],
            },
            {
                version: '4.9.5.1',
                title: '26.10.2025 - Manager Produkcji',
                notes: [
                    'Nowe pole czas realizacji komponentu w dniach, biblioteka komponentów',
                    'Wyświetlanie czasu realizacji komponentu w kalendarzu Mangera Produkcji wyliczanie pierwszego terminu realizacji komponentu',
                    'Możliwość planowania tj. podziału dostaw komponentu w kalendarzu Mangera Produkcji',
                    'Moliwość usunięcia podzielonych "Wyzeruj" dostaw komponentu w kalendarzu Mangera Produkcji',
                    'Możliwość definiowania zrealizowanych oraz dostaw częściowych komponentu w kalendarzu Mangera Produkcji',
                    'Możliwość edycji wartości odbioru oraz dostawy częściowej w oknie Odbioru Dostawy',
                    'Wyświetlanie komunikatów o nadwyzce odebrancyh i zaplanowanych komponentów',
                    'Informacje o opóźnieniach w dostawie komponentów w kalendarzu Mangera Produkcji',
                    'Walidacja podziału dostaw w kalendarzu Mangera Produkcji',
                    'Walidacja odbioru dostaw w kalendarzu Mangera Produkcji',
                    'Wyświetlanie odpowiednich ikon statusu w kalendarzu Mangera Produkcji',
                    'Wyświetlanie odpowiednich tooltipów na slotach w kalendarzu Mangera Produkcji w zaleności od statusu',
                ],
            },
            {
                version: '4.9.5',
                title: '23.10.2025',
                notes: ['Główny układ i layout dostosowany do nowych designów UI'],
            },
            {
                version: '4.9.4',
                title: '22.10.2025',
                notes: [
                    'Paginacja zamówień, lista numerów stron wraz z mechanizmem przełączaniem stron następna/poprzednia',
                ],
            },
            {
                version: '4.9.3',
                title: '16.10.2025',
                notes: [
                    'Szczegóły zamówienia: Odbiory: Rozwijanie listy dostawców',
                    'Szczegóły zamówienia: Manager produkcji: Uaktualniony widok, więcej danych zaciąganych z backendu',
                ],
            },
            {
                version: '4.9.2',
                title: '15.10.2025',
                notes: [
                    'Szczegóły zamówienia: Odbiory: Pobieranie listy dostawców z backendu',
                    'Szczegóły zamówienia: Manager produkcji: Pobieranie listy specyfikacji i wariantów komponentów z backendu',
                    'Inbox: Dodawanie kanału: Fix UI',
                    'Kreator zamówienia: Zatwierdzenie przenosi usera do Szczegółów zamówienia',
                ],
            },
            {
                version: '4.9.1',
                title: '14.10.2025',
                notes: [
                    'Fix: Podwójne wywoływanie "addChat" - Nie trzeba odświeżąć strony przy otwieraniu Chata w nowej specyfikacji/folderze',
                    'Fix: Popawki UI w Inbox',
                    `Szczegóły zamówienia - Odbiory - Tooltip otwierający się po najechaniu kursorem na nazwę i odczekaniu dwóch sekund`,
                    `Szczegóły zamówienia - Odbiory - Pokazywanie/chowanie kolumn w widoku`,
                ],
            },
            {
                version: '4.9.0',
                title: '08.10.2025 - Chat & Notyfikacje',
                notes: [
                    'Zarządzanie członkami kanałów (dodawanie/usuwanie)',
                    'Konwersacje przypisane do specyfikacji i folderów',
                    'Automatyczne czyszczenie danych po usunięciu projektów',
                    'Komunikaty o usuniętych konwersjach',
                    'Dedykowana sekcja "Wzmianki" w skrzynce odbiorczej',
                    'Lista członków kanału z możliwością zarządzania',
                    'Filtrowanie konwersji po członkostwie i wzmiankach',
                    'Powiadomienia o dodaniu/usunięciu z kanału',
                ],
            },
        ],
    },
    {
        date: '09/2025',
        versions: [
            {
                version: '4.8.9',
                title: '30.09.2025 - Chat Komunikacja w Czasie Rzeczywistym',
                notes: [
                    'Implementacja WebSocket dla komunikacji real-time',
                    'Wiadomości i powiadomienia w czasie rzeczywistym (bez odświeżania strony)',
                    'Liczniki nieprzeczytanych wiadomości w konwersjach',
                    'Globalny licznik nieprzeczytanych w górnym pasku',
                    'Czerwone kropki przy konwersjach z nowymi wiadomościami',
                    'Automatyczne oznaczanie wiadomości jako przeczytane',
                    'Synchronizacja liczników między urządzeniami',
                    'Automatyczne ponowne łączenie przy utracie połączenia',
                    'Persystencja liczników w bazie danych',
                    'Historia wszystkich powiadomień',
                ],
            },
            {
                version: '4.8.8',
                title: '28.09.2025',
                notes: [
                    'Komponent kalendarza',
                    'Komponent kalendarza z wybieraniem zakresu dat',
                    'Fix: Komponentu Dropdown (wyświetlanie kalendarza)',
                    'Statyczne popupy planowania i odbierania zamówień',
                ],
            },
            {
                version: '4.8.7',
                title: '25.09.2025',
                notes: [
                    'Zamówienie: Rozbudowa statycznych widoków kalendarza i managera produkcji.',
                    'Zamówienie: Dodatkowe opcje poruszania się po kalendarzu.',
                    'Fix: Przy przeniesieniu folderu, odświeź listę folderów po lewej stronie',
                    'Fix: Przenoszenie folderów: Folder rodzic/dziecko folderu przenoszonego nie może zostać wybrany przez użytkownika',
                    'Fix: Naprawa błędów lintera',
                    'Testy E2E: Przenoszenie folderów',
                ],
            },
            {
                version: '4.8.6',
                title: '17.09.2025 - Oznaczanie uytkowników w konwersacjach',
                notes: [
                    'Oznaczanie użytkowników w konwersacjach (Chat i Inbox)',
                    'Fix ponownego ładowania przy nowododanej konwersacji',
                    'Fix koloru buttonów z folderami przy przenoszeniu specyfikacji/folderu',
                ],
            },
            {
                version: '4.8.5',
                title: '17.09.2025',
                notes: ['Fix generowania pliku PDF specyfikacji'],
            },
            {
                version: '4.8.4',
                title: '17.09.2025',
                notes: ['Fix generowania pliku PDF specyfikacji'],
            },
            {
                version: '4.8.3',
                title: '13.09.2025',
                notes: [
                    'Backendowa obsługa oznaczania użytkowników w konwersacjach',
                    'Rozszerzenie schematu oraz implementacja opcji oznaczania bez warstwy wizualnej',
                ],
            },
            {
                version: '4.8.2',
                title: '11.09.2025',
                notes: ['Statyczny widok dostaw'],
            },
            {
                version: '4.8.1',
                title: '10.09.2025',
                notes: [
                    'Wyświetlanie chata specyfikacji/folderu na dowolnej podstronie',
                    'Poprawa oznaczania notyfikacji jako przeczytanej',
                    'Linkowanie wiadomości prywatnych',
                ],
            },
            {
                version: '4.8.0',
                title: '09.09.2025 - Przenoszenie',
                notes: [
                    'Przenoszenie specyfikacji pomiędzy wszystkimi folderami',
                    'Przenoszenie folderów pomiędzy wszystkimi folderami',
                ],
            },
        ],
    },
    {
        date: '08/2025',
        versions: [
            {
                version: '4.7.4',
                title: '20.08.2025',
                notes: [
                    'Dodanie dropdowna z wyborem waluty w widoku kosztów komponentów z możliwością zmiany waluty.',
                    'Wyświetlanie informacji o nieuzupełnionej specyfikacji w przypadku braku podanych cen wariantów komponentów.',
                    'Wyświetlanie informacji przy komponencie z brakującymi cenami wariantów komponentów.',
                ],
            },
            {
                version: '4.7.3',
                title: '18.08.2025',
                notes: ['Naprawienie błędu pojawiającego się na main przy dodawaniu kosztów komponentów.'],
            },
            {
                version: '4.7.2',
                title: '04.08.2025',
                notes: [
                    'Inbox: Zmiana nazw i routing z `Chat` na `Inbox`',
                    'Inbox: Usuwanie kanału',
                    'Operatorzy: Tabela: Pojawił się drugi scroll (gruby), który przesuwa wartości tabeli, a nie przesuwa headera tabeli.',
                    'Komponent: Warianty: W belce z informacjami o wariancie dodać informację o rozmiarze (lub inny występujący parametr)',
                    'Specyfikacja: Komponenty: Dodanie ikonki usuń (przy komponencie)',
                    'Specyfikacja: Zużycie: Gdy w Wolumenie usunę rozmiar to w Zużyciu też nie powinien się wyświetlać',
                    'Specyfikacja: Warianty: Dodanie sortowania alfabetycznego.',
                    'Specyfikacja: Warianty: Ustawienie stałej szerokości wyboru koloru/rozmiary na sztywno (tak aby nie zmieniała się przy zmianie koloru/rozmiaru)',
                    'Specyfikacja: Warianty: Kolory mają przypisane możliwe do wybrania z nimi rozmiary. Musimy okroić listę dropdown z rozmiarów, których nie możemy wybrać po wybraniu koloru',
                ],
            },
        ],
    },
    {
        date: '07/2025',
        versions: [
            {
                version: '4.7.1',
                title: '24.07.2025',
                notes: ['Chat: Fix kilkukrotnego zapytania addConversation'],
            },
            {
                version: '4.7.0',
                title: '24.07.2025 - Główny Chat',
                notes: [
                    'Chat: Dodawanie kanałów/prywatnych wiadomości',
                    'Chat: Dodawanie wiadomości w kanałach/prywatnych wiadomościach',
                ],
            },
            {
                version: '4.6.2',
                title: '21.07.2025',
                notes: [
                    'Komponenty: Fix ładowania listy komponentów',
                    'Chat: Fix dodawania wiadomości do chatu specyfikacji/folderu',
                    'Notyfikacje: Dodanie autora notyfikacji w dropdownie w topbarze',
                    'Notyfikacje: Podstrona z wszystkimi notyfikacjami',
                ],
            },
            {
                version: '4.6.1',
                title: '18.07.2025',
                notes: [
                    'Notyfikacje: Taby',
                    'Notyfikacje: Tłumaczenia',
                    'Notyfikacje: Oznacz wszystkie jako przeczytane',
                    'Notyfikacje: Dodano autora powiadomienia do bazy danych',
                    'Notyfikacje: Zwrot danych o nadawcy oraz odbiorcy powiadomienia',
                    'Notyfikacje: Odznaczanie wszystkich nieodczytanych powiadomień',
                ],
            },
            {
                version: '4.6.0',
                title: '16.07.2025 - Notyfikacje',
                notes: [
                    'Moduł backendowy powiadomień wraz z migracją bazy danych dla tabeli powiadomień',
                    'API do pobierania wszystkich powiadomień, nieprzeczytanych powiadomień oraz oznaczania powiadomień jako przeczytane',
                    'Wstępne ostylowanie dropdowna z listą notyfikacji',
                    'Fix: Specyfikacje: Chat: Wyświetlanie pustego chatu w nowej specyfikacji/folderze',
                ],
            },
            {
                version: '4.5.1',
                title: '15.07.2025',
                notes: [
                    'BigSpec: Komponenty: Dynamiczna zmiana wysokości modala',
                    'BigSpec: Komponenty: Możliwość edytowania/dodawania wariantów',
                    'Komponent: Warianty: Pokazanie podglądu koloru (jeśli jest dodany)',
                ],
            },
            {
                version: '4.5.0',
                title: '11.07.2025',
                notes: [
                    'Zapis koloru w wariantach komponentów w bazie danych dla akcji dodaj i edycja wariantu. Rozbudowa zwrotu koloru z backendu do colorpicker.',
                    'Warianty: Wyświetlanie koloru podglądowego w wariantach komponentów w dropdownie i zaznaczenie wybranego koloru przez colorpicker.',
                ],
            },
            {
                version: '4.4.5',
                title: '08.07.2025',
                notes: [
                    'BigSpec: Chat: Hotfix przy przechodzeniu pomiędzy chatami - niekończące się ładowanie i brak możliwości zamknięcia chata bez odświżenia strony.',
                ],
            },
            {
                version: '4.4.4',
                title: '08.07.2025',
                notes: ['BigSpec: Warianty: Hotfix przypisywania innego koloru dla różnych wariantów'],
            },
            {
                version: '4.4.3',
                title: '07.07.2025',
                notes: [
                    'Specyfikacja duża: Button zatwierdzenia + drop down z pozostałymi akcjami',
                    'Operatorzy: Nowy styl tabeli',
                    'Wydania: Nowy styl tabeli',
                    'Stylowanie scrollbarów',
                    'Specyfikacja duża: Komponenty: Rozszerzenie modala z wyborem komponentu',
                    'Specyfikacja duża: Warianty: Wyświetlanie unikalnych wartości wariantów komponentów (kolorów i rozmiarów) w dropdownie',
                ],
            },
            {
                version: '4.4.2',
                title: '03.07.2025',
                notes: [
                    'ChatInbox: Odpowiedzi, Oznaczenia, Notyfikacje z zamockowanymi danymi',
                    'ChatInbox: Wyświetlanie avatara obok nazwy autora wiadomości',
                    'ChatInbox/Specyfikacja Duża Komentarze: Grupowanie wiadomości tak aby nie duplikować wyświetlania danych (autor, data dodania) przy dodaniu przez jednego autora kilku wiadomości z rzędu. Data pod wiadomością pojawia się w takim przypadku tylko wtedy gdy wiadomość została wysłana innego dnia. Najechanie na wiadomość pokazuje w tooltipie dokładną datę i godzinę dodania wiadomości.',
                ],
            },
            {
                version: '4.4.1',
                title: '02.07.2025',
                notes: ['Build fix'],
            },
            {
                version: '4.4.0',
                title: '02.07.2025 - Chat',
                notes: [
                    'Chat: Widok główny z zamockowanymi danymi testowymi.',
                    'Avatar: Wyświetlanie inicjałów uytkownika w przypadku braku zdjęcia',
                ],
            },
        ],
    },
    {
        date: '06/2025',
        versions: [
            {
                version: '4.3.3',
                title: '31.06.2025',
                notes: [
                    'Synchronizacji nowych wariantów dla snapshota specyfikacji,',
                    'Przycisk synchronizacji w widoku specyfikacji, obsługujący operację synchronizacji oraz odświeżający dane specyfikacji po jej pomyślnym wykonaniu',
                ],
            },
            {
                version: '4.3.2',
                title: '29.06.2025',
                notes: [
                    'Poprawiono działanie ColorPickera - wyeliminowanie crashowania aplikacji w momencie przesuwania suwakiem wyboru koloru.',
                    'Modal: Małe modale w specyfikacjach - ostylowanie zgodnie z Figmą,',
                    'Modal: Brakujące dane specyfikacji - ostylowanie zgodnie z Figmą.',
                    'Wydania wersji - ostylowanie podobnie do modala brakujących danych przy specyfikacji.',
                    'Dropdown: Stylowanie (minimalna szerokość, odstępy) zgodnie z figmą',
                    'Globalne dodanie ikon do buttonów "Edytuj" i "Usuń".',
                    'BigSpec: Komponenty: Przy dodawaniu komponentu z tego poziomu kliknięcie w "backdrop" nie zamyka sidebara.',
                    'Biblioteka komponentów: Po najechaniu myszką na nazwę komponentu, pojawia się pełna nazwa.',
                    'Komponent: Warianty: Walidacja ceny i waluty (podanie ceny wymaga podania waluty)',
                    'Specyfikacje: Wszystkie pliki -> Moje pliki',
                    'Ostylowanie globalnego toasta błędu z backendu',
                ],
            },
            {
                version: '4.3.1',
                title: '24.06.2025',
                notes: [
                    'Poprawiono wygląd Tabel w Dostawcach oraz w Kosztach / Specyfikacja duza.',
                    'Przyklejony główby topbar ten z avatarem uzytkownika.',
                    'Dodano zakładkę: Wydania wersji.',
                ],
            },
            {
                version: '4.3.0',
                title: '23.06.2025 - Modale i Tabele: Poprawiony i wygląd i zachowanie scroll',
                notes: [
                    'Ostylowany globalny komunikat błędu wysyłany przez backend API.',
                    'Nowy wygląd modal window: poprawiono wygląd oraz scrollbar.',
                    'Naprawiony Capture Screenshot: problem zawieszania się przy zmianie rozmiaru okna do sfotografowania.',
                    'Dostosowanie testów jednonstkowych do nowego wyglądu.',
                ],
            },
            {
                version: '4.2.2',
                title: '18.06.2025',
                notes: [
                    'Dzielenie kodu na części (chunks) w trybie produkcyjnym Webpacka. Problem z brakiem widoczności najnowszej wersji aplikacji po wgraniu na środowisko.',
                ],
            },
            {
                version: '4.2.1',
                title: '18.06.2025',
                notes: [
                    'Czat: możliwość dodawania zdjęć do komentarzy.',
                    'Czat: zmiana formatu daty przy przełączaniu języka aplikacji.',
                    'Czat: Przy pustym czacie wiadomości są wyrównane do górnej krawędzi.',
                    "Zmiana nazwy sekcji 'Foldery' na 'Wszystkie foldery'.",
                    'Eksport specyfikacji z aktualnego folderu do pliku XLSX.',
                    'Preloader: zastąpiono Skeleton loader animacją Loading Spinner.',
                    'Zamówienia i Wydania magazynowe: poprawiono wygląd okna wyboru specyfikacji.',
                    'Taby w specyfikacji: poprawiono skakanie elementów podczas ładowania.',
                    'Specyfikacje Header: zmniejszono odstęp nagłówka od krawędzi.',
                    'Specyfikacja: InputNumber - powiększono pole do wpisywania.',
                    'Specyfikacja: sekcja "Informacje ogólne" - zmiana wielkości fontów.',
                    'Na większych rozdzielczościach: lepsze skalowanie okna i dodanie kolumn zamiast ich rozciągania.',
                ],
            },
            {
                version: '4.2.0',
                title: '17.06.2025 - Chat + Screenshot',
                notes: [
                    'Chat: Zaprogramowanie funkcjonalności dla specyfikacji i folderu',
                    'Screenshot: Zaprogramowanie funkcjonalności dla specyfikacji i folderu',
                    'Dodano możliwość wykonywania zrzutów ekranu specyfikacji.',
                    'Dashboard: minimalna wysokość kontenera rozciąga się na całą wysokość okna.',
                    'Okno dialogowe: poprawiono szerokość buttona i wyrównanie ikon w opcji dodawania specyfikacji/katalogu.',
                ],
            },
            {
                version: '4.1.2',
                title: '13.06.2025',
                notes: [
                    'Edycja nazwy szkicu',
                    'Sticky FilterBar oraz Sticky Sidemenu dla lepszej nawigacji.',
                    'Główny kontener aplikacji rozciągnięty na całą szerokość okna przeglądarki',
                    'Box katalogu: dodano efekt hover oraz zmianę koloru obramowania.',
                    'Specyfikacja: wybór komponentu - efekt hover dla CategoryBox.',
                ],
            },
            {
                version: '4.1.1',
                title: '04.06.2025',
                notes: [
                    "Usunięto zakładki 'Latest' i 'Drafts' z widoku Specyfikacji.",
                    'Filtrowanie specyfikacji',
                ],
            },
            {
                version: '4.1.0',
                title: '02.06.2025 - Komentarze Specyfikacji',
                notes: [
                    'Duża specyfikacja: Edytor wizualny/Komentarze',
                    'Mała specyfikacja: podgląd edytora w sekcji komentarzy.',
                ],
            },
        ],
    },
];
export default releases;
